export var EnterprisePriceCalculationsError;
(function (EnterprisePriceCalculationsError) {
    EnterprisePriceCalculationsError["INVALID_TIER"] = "INVALID_TIER";
    EnterprisePriceCalculationsError["MIN_USERS_ERROR"] = "MIN_USERS_ERROR";
    EnterprisePriceCalculationsError["MAX_USERS_ERROR"] = "MAX_USERS_ERROR";
})(EnterprisePriceCalculationsError || (EnterprisePriceCalculationsError = {}));
export function accumulatedEnterpriseTiers(tiers) {
    const sortedTiers = [...tiers].sort((a, b) => a.above - b.above);
    const accumulatedTiers = sortedTiers.reduce((accumulated, tier, i) => {
        if (i === 0) {
            accumulated[i] = Object.assign(Object.assign({}, tier), { prevTierAccumulatedPrice: 0 });
        }
        else {
            const prev = accumulated[i - 1];
            accumulated[i] = Object.assign(Object.assign({}, tier), { prevTierAccumulatedPrice: (tier.above - prev.above) * prev.at + prev.prevTierAccumulatedPrice });
        }
        return accumulated;
    }, []);
    return accumulatedTiers.sort((a, b) => b.above - a.above);
}
export class EnterprisePricingCalculator {
    constructor(tiers, minUsers = 1, maxUsers = 10000000) {
        this.defaultCalculations = {
            annualPrice: '0',
            annualPricePerUser: '0.00',
            monthlyPricePerUser: '0.00'
        };
        this.tiers = accumulatedEnterpriseTiers(tiers);
        this.minUsers = minUsers;
        this.maxUsers = maxUsers;
    }
    getPricesByUserCount(userCount) {
        const tier = this.tiers.find((tier) => userCount > tier.above);
        if (userCount < this.minUsers) {
            return [
                EnterprisePriceCalculationsError.MIN_USERS_ERROR,
                this.defaultCalculations
            ];
        }
        if (userCount > this.maxUsers) {
            return [
                EnterprisePriceCalculationsError.MAX_USERS_ERROR,
                this.defaultCalculations
            ];
        }
        if (!tier) {
            return [
                EnterprisePriceCalculationsError.INVALID_TIER,
                this.defaultCalculations
            ];
        }
        const annualPrice = (userCount - tier.above) * tier.at + tier.prevTierAccumulatedPrice;
        const annualPricePerUser = annualPrice / userCount;
        const monthlyPricePerUser = annualPricePerUser / 12;
        return [
            undefined,
            {
                annualPrice: annualPrice.toLocaleString('en', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                }),
                annualPricePerUser: annualPricePerUser.toLocaleString('en', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }),
                monthlyPricePerUser: monthlyPricePerUser.toLocaleString('en', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            }
        ];
    }
}
//# sourceMappingURL=enterprise-pricing-calculator.js.map